import Vue from 'vue'

const isMaintenanceModeEnabled = (process.env.VUE_APP_MAINTENANCE_MODE === 'true') || false
// window.console.log = () => {}
// window.console.error = () => {}
// window.console.warn = () => {}

window.speakol_configs = {
  stripePublicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
  checkoutPublicKey: process.env.VUE_APP_CHECKOUT_PUBLIC_KEY,
  env: process.env.VUE_APP_ENV,
  checkout_payment_frame_cdn: 'https://cdn.checkout.com/js/framesv2.min.js',
  test_tracking_connection_param: process.env.VUE_TEST_TRACKING_CONNECTION_PARAM || 'spcid',
  test_tracking_connection_prefix: process.env.VUE_TEST_TRACKING_CONNECTION_PREFIX || 'spkdbg'
}

// tooltip
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)

/**
 * Enable sentry only in case APP_DEBUG is false
 */
import * as Sentry from '@sentry/browser'
import {Vue as VueIntegration} from '@sentry/integrations'
import {Integrations} from '@sentry/tracing'

const enableDebugging = !!process.env.VUE_APP_DEBUG

if (!enableDebugging && !isMaintenanceModeEnabled) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    release: process.env.VUE_APP_SENTRY_RELEASE,
    environment: process.env.VUE_APP_SENTRY_RELEASE,
    integrations: [
      new VueIntegration({
        Vue,
        tracing: true
      }),
      new Integrations.BrowserTracing()
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0
  })
}

import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

//
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_ANALYTICS_ID,
    send_page_view: true
  }
})

// import {VueReCaptcha} from 'vue-recaptcha-v3'
// Vue.use(VueReCaptcha, {
//   siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY
// })

import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

import LaravelVuePagination from 'laravel-vue-pagination'

Vue.component('pagination', LaravelVuePagination)

// axios
import axios from './baseAxios.js'

window.axios = axios

// i18n
import i18n from './i18n/i18n'

// VeeValidate
import VeeValidate from 'vee-validate'
import VeeValidateLaravel from 'vee-validate-laravel' // check: https://github.com/RobertGlynWilliams/vee-validate-laravel
Vue.use(VeeValidate)
Vue.use(VeeValidateLaravel)

// custom validations
import './validators/password'

// override messages
import './validators/overwrite'

import DateRangePicker from 'vue2-daterange-picker'

Vue.component('date-range-picker', DateRangePicker)

import ApexCharts from 'vue-apexcharts'

Vue.component('ApexCharts', ApexCharts)


import LiquorTree from 'liquor-tree'
// global registration
Vue.use(LiquorTree)

// Filters
import './filters/filters.js'

import addComma from './filters/addComma.js'

Vue.filter('addComma', addComma)


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'

// Vuex Store
import store from './store/store'

import './helpers/checkPermissions'

// Vue Router
import router from './router'

// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'

Vue.use(VueHammer)

import VueMoment from 'vue-moment'

Vue.use(VueMoment)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Sweetalert2
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

Vue.use(VueSweetalert2)

// import vue-panzoom
import panZoom from 'vue-panzoom'
// install plugin
Vue.use(panZoom)

// vue-phone-number-input
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

Vue.component('vue-phone-number-input', VuePhoneNumberInput)

// Feather font icon
require('./assets/css/iconfont.css')

// Speakol Icons
require('./assets/css/speakol.css')

Vue.config.productionTip = false

// helpers
import {vErrors} from './helpers/vErrors.js'

Vue.prototype.$vErrors = vErrors

import VueIntercom from 'vue-intercom'

Vue.use(VueIntercom, {appId: 'c42xzalp'})

import Hotjar from 'vue-hotjar'


if (!isMaintenanceModeEnabled) {

  Vue.use(Hotjar, {
    id: '693812', // Hotjar Site ID
    isProduction: true
  })
}

import checkView from 'vue-check-view'
Vue.use(checkView)

import {constants} from '@/utils/Constants.js'

Vue.prototype.$constants = constants

export const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  data: {
    isGeneralError: false
  }
}).$mount('#app')
